module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_decollte-38e066fa02eb799e4de73b8c5d461367.svg";